'use strict';

exports.__esModule = true;

var _AnalyticsManager = require('./AnalyticsManager/AnalyticsManager');

var _AnalyticsManager2 = _interopRequireDefault(_AnalyticsManager);

var _BaseAnalyticsDataHandler = require('./AnalyticsManager/BaseAnalyticsDataHandler');

var _BaseAnalyticsDataHandler2 = _interopRequireDefault(_BaseAnalyticsDataHandler);

var _BaseGoogleTagManagerDataHandler = require('./providers/googleTagManager/BaseGoogleTagManagerDataHandler');

var _BaseGoogleTagManagerDataHandler2 = _interopRequireDefault(_BaseGoogleTagManagerDataHandler);

var _Purchase = require('./providers/googleTagManager/enhancedEcommerce/Purchase');

var _Purchase2 = _interopRequireDefault(_Purchase);

var _CheckoutStep = require('./providers/googleTagManager/enhancedEcommerce/CheckoutStep');

var _CheckoutStep2 = _interopRequireDefault(_CheckoutStep);

var _CheckoutOption = require('./providers/googleTagManager/enhancedEcommerce/CheckoutOption');

var _CheckoutOption2 = _interopRequireDefault(_CheckoutOption);

var _DigitalOfferRedemptionEvent = require('./providers/googleTagManager/events/DigitalOfferRedemptionEvent');

var _DigitalOfferRedemptionEvent2 = _interopRequireDefault(_DigitalOfferRedemptionEvent);

var _constants = require('./providers/googleTagManager/constants');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    BaseAnalyticsDataHandler: _BaseAnalyticsDataHandler2.default,
    AnalyticsManager: _AnalyticsManager2.default,
    providers: {
        googleTagManager: {
            BaseGoogleTagManagerDataHandler: _BaseGoogleTagManagerDataHandler2.default,
            enhancedEcommerce: {
                Purchase: _Purchase2.default,
                CheckoutStep: _CheckoutStep2.default,
                CheckoutOption: _CheckoutOption2.default
            },
            events: {
                DigitalOfferRedemptionEvent: _DigitalOfferRedemptionEvent2.default
            },
            constants: _constants2.default
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/analytics/newAnalyticsExports.js
// module id = 851
// module chunks = 0